import { z } from 'zod';

export const siteDtoSchema = z.object({
  id: z.string().uuid(),
  companyId: z.string().uuid(),
  name: z.string().min(1).max(255),
  addressLine1: z.string().max(255).nullable(),
  addressLine2: z.string().max(255).nullable(),
  postalCode: z.string().max(20).nullable(),
  city: z.string().max(255).nullable(),
  country: z.string().max(255).nullable(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export const siteCreateSchema = z.object({
  name: z
    .string()
    .min(1, { message: 'Le nom du site est obligatoire' })
    .max(255, { message: 'Le nom ne doit pas dépasser 255 caractères' }),
  addressLine1: z
    .string()
    .max(255, { message: 'L’adresse ne doit pas dépasser 255 caractères' })
    .optional(),
  addressLine2: z
    .string()
    .max(255, { message: 'L’adresse ne doit pas dépasser 255 caractères' })
    .optional(),
  postalCode: z
    .string()
    .max(20, { message: 'Le code postal ne doit pas dépasser 20 caractères' })
    .optional(),
  city: z.string().max(255, { message: 'La ville ne doit pas dépasser 255 caractères' }).optional(),
  country: z
    .string()
    .max(255, { message: 'Le pays ne doit pas dépasser 255 caractères' })
    .optional(),
});

export const siteUpdateSchema = siteCreateSchema.partial();

export type SiteDto = z.infer<typeof siteDtoSchema>;
export type SiteCreateInput = z.infer<typeof siteCreateSchema>;
export type SiteUpdateInput = z.infer<typeof siteUpdateSchema>;
